import { createAction } from '@reduxjs/toolkit'

const prefix = 'signIn'

const refreshToken = createAction(`${prefix}/refreshToken`)
const signOut = createAction(`${prefix}/signOut`)

export const signInActions = { signOut, refreshToken }
